/**
 * BDA-5879 — IDs for the Behandlerart (employment / practice type) of a
 * licensed physician.
 *
 * Mirrors the existing `schwerpunkt.ts` shape
 * (type union + values constant + display-name Record). The backend only
 * stores/accepts the kebab-case keys; the labels live here.
 */
export type BdBehandlerart = 'im-mvz' | 'niedergelassen' | 'praxis-angestellt';

export const BD_BEHANDLERARTEN: BdBehandlerart[] = [
  'im-mvz',
  'niedergelassen',
  'praxis-angestellt',
];

export const BD_BEHANDLERART_DISPLAY_NAME: Record<BdBehandlerart, string> = {
  'im-mvz': 'Im MVZ',
  niedergelassen: 'Niedergelassen',
  'praxis-angestellt': 'Praxis-Angestellt',
};
